import { Button } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  title: string;
  type: string;
}

const HowItWorksLink: FC<IProps> = ({ title, type }) => (
  <Link
    to={`/how-it-works/${type}`}
    target="_blank"
    rel="noreferrer"
    key="how-it-works"
  >
    <Button type="default" size="large">
      {title}
    </Button>
  </Link>
);

export default HowItWorksLink;
